export default () => {
    const wholesale = document.querySelector(".in-wholesale");

    if (wholesale) {
        var sendButton = document.querySelector(".send-wholesale-form");

        if (sendButton)
        {
            sendButton.addEventListener("click", () => {
                var fullName = document.querySelector("#fullname").value;
                var email = document.querySelector("#email").value;
                var shippingCountry = document.querySelector("#shippingcountry").value;
                var shippingAddress = document.querySelector("#shippingaddress").value;
                var businessName = document.querySelector("#businessname").value;
                var website = document.querySelector("#website").value;
                var description = document.querySelector("#description").value;
                var info = document.querySelector("#info").value;

                var emailSubject = `Wholesale contact form - ${businessName} - ${fullName}`;
                var emailBody = `Wholesale contact form data:%0D%0A%0D%0AFull name: ${fullName}%0D%0AEmail: ${email}%0D%0AShipping country: ${shippingCountry}%0D%0A`
                                + `Shipping address: ${shippingAddress}%0D%0ABusiness name: ${businessName}%0D%0AWebsite: ${website}%0D%0ADescription: ${description}`
                                + `%0D%0AInfo: ${info}`;

                sendButton.href = `mailto:roastery@theminers.eu?subject=${emailSubject}&body=${emailBody}`;
            });
        }
    }
};